// ContactInfo.js
import { Mail, Phone, Globe, Home } from "lucide-react";
import styles from "./VCFViewer.module.css";

const icons = {
    tel: Phone,
    email: Mail,
    url: Globe,
    adr: Home
}

const formatValue = (value) => {
    if (typeof value === 'object') {

        const {street, postalCode, locality, country} = value;

        // Check if address value is string or array, if not assign an empty string
        const formatAddressField = (field) => Array.isArray(field) ? field.join(', ') : (typeof field === 'string' ? field : '');

        // Join all address parts with commas. Ignore parts that resolve to an empty string
        return [street, postalCode, locality, country]
            .map(formatAddressField)
            .filter(Boolean) // Remove empty strings
            .join(', ');
    }

    return Array.isArray(value) ? value.join(', ') : (value || '');
}

const ContactInfo = ({ type, info }) => {
    const Icon = icons[type]

    return (
        <div className={`${styles.contactItem} contactItem`}>
            <Icon className={styles.icon}/>
            <ul>
                { info.map((i, index) => {
                    // Create a unique key from the value, fallback to index if value is not suitable
                    const valueKey = typeof i.value === 'string'
                        ? i.value.replace(/\s+/g, '-').substring(0, 50)
                        : `${type}-${index}`;
                    return <li key={valueKey}>{formatValue(i.value)}</li>;
                })}
            </ul>
        </div>
    );
};

export default ContactInfo;